import type { SexSchema } from '@coas/validators/const';
import { api } from 'trpc/react';

export const useCategoriesBySex = (sex: SexSchema, enabled: boolean) => {
    return api.category.getAllClear.useQuery({ sex }, { enabled });
};

export const useIndicators = (args: {
    productIds: string[];
    sexTab: SexSchema;
    categoryIds: string[];
    enabled: boolean;
}) => {
    const guardIds = args.categoryIds.length ? args.categoryIds : [];
    return api.product.indicators.useQuery(
        { productIds: args.productIds, sexTab: args.sexTab, categoryIds: guardIds },
        { enabled: args.enabled && args.categoryIds.length > 0 },
    );
};
